import React, { memo } from 'react';
import { TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

const TableHeader = memo(({ onSort, sortBy, sortDirection }) => {

    const getSortIcon = (column) => {

        if (sortBy === column) {
            return sortDirection === "asc" ?
                <KeyboardArrowUpIcon fontSize='small' /> :
                <KeyboardArrowDownIcon fontSize='small' />;
        }

        return <UnfoldMoreIcon fontSize='small' />
    };

    // TODO: Add the columnID for Last Reviewed By, when ReviewerID will be implementing
    const columns = [
        { id: 'applicationId', label: 'Application ID', sortable: true },
        { id: 'email', label: 'User ID', sortable: true },
        { id: 'idvEndTimestamp', label: 'Submitted Date', sortable: true },
        { id: 'userId', label: 'Last Reviewed By', sortable: true },
        { id: '', label: 'Status', sortable: false }
    ];

    return (
        <TableHead
            sx={{
                backgroundColor: 'var(--header-dark)',
                fontFamily: 'var(--font-secondary)',
                "&:hover": { backgroundColor: 'var(--header-dark', cursor: "pointer" },
                "& th": { color: "white" },
                "& tr:hover": { backgroundColor: "#002D62 !important" }, // Prevent row hover

            }}>
            <TableRow>
                {columns.map(column => (
                    <TableCell
                        key={column.id}
                        className='table-cell'
                        sx={{
                            padding: "12px",
                            fontSize: "0.85rem",
                            color: "white",
                            cursor: "pointer",
                            userSelect: "none",
                            '&:hover': {
                                color: "white"
                            }
                        }}>
                        {column.sortable ?
                            <TableSortLabel
                                active={sortBy === column.id}
                                onClick={() => onSort(column?.id)}
                                IconComponent={() => getSortIcon(column.id)}
                                sx={{
                                    color: "white",
                                    "&:hover": {
                                        color: "white",
                                    },
                                    "&.Mui-active": {
                                        color: "white"
                                    }
                                }}>
                                {column.label}
                            </TableSortLabel>
                            :
                            column.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
});

export default TableHeader;
